export const supportedLanguages = ['fr', 'en', 'es', 'it', 'de'];
